import React from 'react';
import CountdownTimer from '../Components/CountdownTimer';


const InfoBodySaving = () => {
    let drawTime = { date: '', date2: '', time: '', time2: '' }

    const nowDate = new Date();
    const drawSchedule = [
        { date: new Date('2025-02-10T17:00:00'), display: { date: '2025-02-10', date2: '2025.02.10', time: '17:00', time2: '17:00:00' } },
        { date: new Date('2025-03-10T17:00:00'), display: { date: '2025-03-10', date2: '2025.03.10', time: '17:00', time2: '17:00:00' } },
        { date: new Date('2025-04-10T17:00:00'), display: { date: '2025-04-10', date2: '2025.04.10', time: '17:00', time2: '17:00:00' } },
        { date: new Date('2025-05-10T17:00:00'), display: { date: '2025-05-10', date2: '2025.05.10', time: '17:00', time2: '17:00:00' } },
        { date: new Date('2025-06-10T17:00:00'), display: { date: '2025-06-10', date2: '2025.06.10', time: '17:00', time2: '17:00:00' } },
        { date: new Date('2025-07-09T17:00:00'), display: { date: '2025-07-09', date2: '2025.07.09', time: '17:00', time2: '17:00:00' } },
        { date: new Date('2025-08-10T17:00:00'), display: { date: '2025-08-10', date2: '2025.08.10', time: '17:00', time2: '17:00:00' } },
        { date: new Date('2025-09-10T17:00:00'), display: { date: '2025-09-10', date2: '2025.09.10', time: '17:00', time2: '17:00:00' } },
        { date: new Date('2025-10-10T17:00:00'), display: { date: '2025-10-10', date2: '2025.10.10', time: '17:00', time2: '17:00:00' } },
        { date: new Date('2025-11-10T17:00:00'), display: { date: '2025-11-10', date2: '2025.11.10', time: '17:00', time2: '17:00:00' } },
        { date: new Date('2025-12-10T17:00:00'), display: { date: '2025-12-10', date2: '2025.12.10', time: '17:00', time2: '17:00:00' } },
        { date: new Date('2026-01-12T17:00:00'), display: { date: '2026-01-12', date2: '2026.01.12', time: '17:00', time2: '17:00:00' } },
        { date: new Date('2026-02-10T17:00:00'), display: { date: '2026-01-10', date2: '2026.01.10', time: '17:00', time2: '17:00:00' } }
    ];

    const nextDraw = drawSchedule.find(draw => nowDate < draw.date);
    if (nextDraw) {
        drawTime = nextDraw.display;
    }


    return (
        <div className='h-fit w-full bg-slate-200 px-40 mobile:px-0 laptop:px-20'>
            <div className='w-full h-full bg-white'>
                <img
                    className='w-full object-cover h-full mobile:hidden'
                    src="./images/HM-2026-2.jfif"
                    alt="banner_thin"
                />

                <img
                    className='w-full object-cover h-full hidden mobile:block'
                    src="./images/HM-2026-1-Mobile.png"
                    alt="banner_thin_mobile"
                />

                <div className='w-full h-full px-36 py-10 space-y-8 mobile:px-4 text-justify tablet:px-16'>
                    <div className='text-center space-y-6'>
                        <div className='max-w-2xl mx-auto'>
                            <p className='text-lg text-gray-600 mobile:text-base'>
                                Байртай, Хадгаламжтай аян Тун удахгүй.
                            </p>
                        </div>
                        <div className='flex justify-center items-center gap-4 pt-8'>
                            <div className='h-1 w-20 bg-gradient-to-r from-transparent via-blue-400 to-blue-500 rounded-full animate-pulse'></div>
                            <div className='relative'>
                                <div className='h-3 w-3 bg-blue-500 rounded-full'></div>
                                <div className='absolute inset-0 h-3 w-3 bg-blue-400 rounded-full animate-ping'></div>
                            </div>
                            <div className='h-1 w-20 bg-gradient-to-l from-transparent via-blue-400 to-blue-500 rounded-full animate-pulse'></div>
                        </div>
                    </div>
                </div>
                {/* 2026 ОНЫ ХУРИМТЛАЛТАЙ МОНГОЛ ЭХЭЛТЭЛ ТҮР БАЙХГҮЙ БОЛГОВ.
                <div className='w-full h-full px-36 py-10 space-y-8 mobile:px-4 text-justify tablet:px-16'>
                    <p className='font-bold text-[#0987F3]'>Харилцагч Танд энэ өдрийн мэнд хүргэе.</p>
                    <p>Урамшуулалт аян 2025.07.01-ээс эхлэн 2025.12.31-ны өдрийг дуустал үргэлжлэх ба сар бүр 50 харилцагчийг шалгаруулан супер тохирлоор нэг харилцагчийг “Нэг өрөө байр” урамшууллын эзнээр тодруулж, нийт 301 харилцагчийн хуримтлуулах дадлыг бид урамшуулах болно. Тухайн сарын урамшууллын эздийг дараа сарын 10-ны өдөр Худалдаа, хөгжлийн банкны албан ёсны Facebook хуудсаар тодруулна.</p>
                    <p>Харилцагч Та 6 сар ба түүнээс дээш сарын хугацаатай хадгаламжаа нэмэгдүүлсэн 100,000₮ тутамдаа урамшууллын нэг эрх авч, энэхүү аянд оролцох боломжтой.</p>

                    <div>
                        <p className='font-bold text-[#0987F3]'>Сар бүрийн урамшуулал</p>
                        <ul className='list-disc ml-5'>
                            <li>1,000,000 төгрөгийн хадгаламжийн эрх - 5 харилцагч</li>
                            <li>500,000 төгрөгийн хадгаламжийн эрх - 10 харилцагч</li>
                            <li>300,000 төгрөгийн хадгаламжийн эрх - 15 харилцагч</li>
                            <li>100,000 төгрөгийн хадгаламжийн эрх – 20 харилцагч</li>
                        </ul>
                    </div>

                    <div>
                        <p className='font-bold text-[#0987F3]'>Супер урамшуулал</p>
                        <p>Аяны төгсгөлд 2025 оны 7-р сараас 12-р сарын хугацаанд нийт урамшууллын эрхтэй харилцагчдаас нэг харилцагч “Нэг өрөө байр”-н эзэн болно.</p>
                        <p>Тохирлыг 25-р суваг телевизээр шууд дамжуулна.</p>
                    </div>


                    <div>
                        <p className='font-bold text-[#0987F3]'>Урамшууллын эрх хэрхэн авах вэ?</p>
                        <ul className='list-disc ml-5'>
                            <li>Урамшуулалт аянд 6 сар ба түүнээс дээш сарын хугацаатай иргэний бүх төрлийн хадгаламжийг 100,000 төгрөгөөр нэмэгдүүлэх тутамд 1 урамшууллын эрх олгогдоно.</li>
                            <li>Мөн тухайн сард Хялбар хуримтлал үйлчилгээнд шинээр бүртгүүлэн 6 сар ба түүнээс дээш сарын хугацаатай хадгаламждаа хуримтлал үүсгэх тохиолдолд 1 эрх олгогдоно.</li>
                            <li>1 харилцагчид хамгийн ихдээ 1,000 эрх олгоно.</li>
                        </ul>
                    </div>

                    <img className='w-full' src="./images/HM-2026-2.png" alt="banner" />

                    <div>
                        <p className='font-bold text-[#0987F3] uppercase'>Урамшууллын эздийг тодруулах өдрүүд</p>
                        <table className='min-w-fit divide-x divide-y border border-solid border-gray-200'>
                            <thead className='px-8 mobile:px-2'>
                                <tr className='bg-[#0987F3] p-8 text-white mobile:p-2'>
                                    <th className='border border-solid border-blue-300 px-4 py-1 mobile:px-1'>Хамрах урамшууллын эрхийн хугацаа</th>
                                    <th className='border border-solid border-blue-300 px-4 py-1 mobile:px-1'>Тохирол болох өдөр</th>
                                    <th className='border border-solid border-blue-300 px-4 py-1 mobile:px-1'>Тохирол болох суваг</th>
                                </tr>
                            </thead>
                            <tbody className='text-center'>
                                <tr>
                                    <td className='border border-solid border-gray-300 px-4 py-1 mobile:px-1'>"2025.07.01 - 2025.07.31"</td>
                                    <td className='border border-solid border-gray-300 px-4 py-1 mobile:px-1'>"2025.08.10"</td>
                                    <td className='border border-solid border-gray-300 px-4 py-1 mobile:px-1' rowSpan={5}>Тохирлыг Худалдаа, хөгжлийн банкны албан ёсны Facebook хуудсаар шууд дамжуулна..</td>
                                </tr>
                                <tr>
                                    <td className='border border-solid border-gray-300 px-4 py-1 mobile:px-1'>"2025.08.01 - 2025.08.31"</td>
                                    <td className='border border-solid border-gray-300 px-4 py-1 mobile:px-1'>"2025.09.10"</td>
                                </tr>
                                <tr>
                                    <td className='border border-solid border-gray-300 px-4 py-1 mobile:px-1'>"2025.09.01 - 2025.09.30"</td>
                                    <td className='border border-solid border-gray-300 px-4 py-1 mobile:px-1'>"2025.10.10"</td>
                                </tr>
                                <tr>
                                    <td className='border border-solid border-gray-300 px-4 py-1 mobile:px-1'>"2025.10.01 - 2025.10.31"</td>
                                    <td className='border border-solid border-gray-300 px-4 py-1 mobile:px-1'>"2025.11.10"</td>
                                </tr>
                                <tr>
                                    <td className='border border-solid border-gray-300 px-4 py-1 mobile:px-1'>"2025.11.01 - 2025.11.30"</td>
                                    <td className='border border-solid border-gray-300 px-4 py-1 mobile:px-1'>"2025.12.10"</td>
                                </tr>
                                <tr>
                                    <td className='border border-solid border-gray-300 px-4 py-1 mobile:px-1'>"2025.12.01 - 2025.12.31"</td>
                                    <td className='border border-solid border-gray-300 px-4 py-1 mobile:px-1'>"2026.01.12"</td>
                                    <td className='border border-solid border-gray-300 px-4 py-1 mobile:px-1' rowSpan={1}>Тохирлыг 25-р суваг телевизээр шууд дамжуулна.</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <p>Илүү их мэдээллийг <a className='text-blue-500 font-bold' target='_blank' href='https://www.tdbm.mn/mn/14013/news'>ЭНД</a> дарж авна уу.</p>
                    <div className='border border-gray-400 p-4'>
                        <p className='font-bold text-red-500'>Санамж</p>
                        <ul className='list-disc ml-5'>
                            <li>Урамшууллын эрх нь зөвхөн 6 сар буюу түүнээс дээш хугацаатай хадгаламж, хүүхдийн хадгаламжид олгогдоно.</li>
                            <li>Харилцагчийн хадгаламжийн үлдэгдэл шалгаруулалтын эхэнд байсан үлдэгдлээс буурсан тохиолдолд урамшууллын эрх олгохгүй.</li>
                            <li>1 харилцагчид хамгийн ихдээ 1,000 эрх олгоно.</li>
                            <li>Сар бүр цуглуулсан урамшууллын эрхээрээ зөвхөн тухайн сарын урамшуулалд оролцох эрхтэй.</li>
                            <li>Таны хадгаламжийн дансандаа хийсэн орлогын дүнд харгалзуулан өдөр бүр урамшууллын эрх олгох ба урамшууллын эрхээ тухайн гүйлгээ хийсэн өдрийн дараагийн өдөр нь шалгах боломжтой. Хэрэв аян үргэлжлэх хугацаанд хадгаламжийн дансны хугацааг цуцалбал танд олгогдсон бүх урамшууллын эрх хүчингүй болно.</li>
                            <li>Тухайн сарын урамшууллын эрхийн дугаар нь дараа сарын 3-нээс 5-ны хооронд үүсэх тул тус хугацаанд урамшууллын эрхийн дугаарыг шалгах боломжтой.</li>
                        </ul>
                    </div>
                    <div className='bg-blue-100 py-10 px-60 tablet:px-2 laptop:px-20 mobile:px-2'>
                        <CountdownTimer targetDate={drawTime.date !== '' ? (drawTime.date + " " + drawTime.time2) : ""} time={drawTime.date !== '' ? (drawTime.date2 + "-ны өдөр " + drawTime.time) : ""} />
                    </div>
                </div> */}
            </div>
        </div>
    );
}

export default InfoBodySaving;